export default {
  //代码里的key(唯一标识): '法语',
  lang: 'fr',
  appIntroduction: ' Film et série à succès Visionner gratuitement à tout moment ',
  noMoreTip: 'Vous avez lu la fin, et il n\'y a plus de contenu~ ',
  navigator: {
    home: ' Page d\'accueil ',
    all: ' Tous les contenus ',
    news: ' Articles et informations ',
    download: ' Télécharger l\'application ',
    contact: 'à propos de nous',
    joinUs: 'Rejoignez-nous'
  },
  seo: {
    title: 'Loklok Watch HD movies online for free',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie,Regardez en ligne,Regardez gratuitement, Regardez des drames gratuitement,new movies,tv show,Snowdrop,Hotel Transylvania,Encanto,The Silent Sea,Jujutsu Kaisen,9-1-1: Lone Star,Hotel Transylvania,Dragons,SnowdropOur Beloved SummerDemon SlayerHappinessSing 2Ranking of KingsDemon SlayerAttack on TitanTrue BeautyVincenzoAttack on Titan The Final SeasonJujutsu KaisenThe HandmaidenTokyo RevengersNeverthelessItaewon ClassSquid GameCrash Landing on YouEuphoriaAttack on TitanHometown Cha-Cha-Cha',
    description: 'Popular episodes updated quickly,American hot series,Tension, comedy, thriller,Newest hottest dramasall in Loklok',
    ogImage: 'https://static.loklok.video/img/tw-en.png',
    index: {
      title: 'Loklok - Regardez des films HD en ligne gratuitement - Top Movies Worldwide',
      keywords: 'Loklok, application Loklok, téléchargement loklok, Regardez en ligne,Regardez gratuitement, Regardez des drames gratuitement,télécharger loklok, loklok pc, loklok apk, loklok ios, loklok android, loklok pour ios, loklok pour android, loklok android tv, loklok chromecast, kdrama, k-drama, drame coréen, box-office, films américains, films occidentaux, films à succès, films thaïlandais, films thaïlandais, séries télévisées, séries télévisées, anime, animation, dessin animé, émission de variétés, yaoi, yuri, bl, gl, hollywood, bollywood, zombies, une pièce, naruto, amour affaire, nous sommes tous morts',
      description: 'Loklok a un grand nombre de films et de contenus télévisés populaires, les séries télévisées et les films les plus récents et les plus populaires sont gratuits à regarder'
    },
    allPage: {
      title: 'Loklok Regardez des films HD en ligne gratuitement, tout ce que vous pouvez imaginer.',
      keywords: 'Loklok, application Loklok, téléchargement loklok, pc loklok, apk loklok, Regardez en ligne,Regardez gratuitement, Regardez des drames gratuitement,animation, anime, films à succès, nouvel épisode, films à venir, nouvelle version 2022, première, science-fiction, douce romance, comédie, action, amour, films gratuits, gratuit films en ligne, application de films gratuite, nous sommes tous morts, F4 Thailand: Boys Over Flowers, Euphoria Season 2, Twenty five vingt one, Forecasting Love and Weather，Ghost Doctor, True Beauty，Encanto, From，Proposition commerciale，Snowdrop，Rookie Flics, toujours 2 ensemble',
      description: 'loklok propose un grand nombre de contenus cinématographiques et télévisuels populaires, des films populaires, des films HD ultra haute définition, 4K, une variété d\'options de sous-titres'
    },
    articles: {
      title: 'Loklok Regardez des films HD en ligne gratuitement, les dernières nouvelles de loklok',
      keywords: 'Loklok, application Loklok, téléchargement loklok, loklok pc, loklok apk,Regardez en ligne,Regardez gratuitement, Regardez des drames gratuitement, dernières informations sur les films et la télévision, recommandations de films, critiques de films populaires, films et télévision 2022, première de film, 2022 à regarder, 2022 à regarder, films de cinéma 2022, films à venir 2023 , Peaky Blinders Saison 6, l\'attaque des titans saison finale, notre été bien-aimé, hotel transylvania 4: transformania, bonheur',
      description: 'Le contenu cinématographique et télévisuel populaire de loklok est instantanément consultable, les dernières informations sur le cinéma et les critiques de films populaires'
    },
    download: {
      title: 'Lokok fournit le téléchargement de la dernière version officielle',
      keywords: 'Loklok, application Loklok, téléchargement loklok, pc loklok, apk loklok, Regardez en ligne,Regardez gratuitement, Regardez des drames gratuitement,téléchargement loklok, téléchargement loklok, téléchargement loklok apk, téléchargement loklok ios, téléchargement loklok android, loklok googleplay, téléchargement pc loklok, dernière version loklok, site officiel loklok, comment télécharger Loklok, bureau Loklok, bloc-notes Loklok',
      description: 'Téléchargez gratuitement l\'application loklok, les derniers films et émissions de télévision en ligne en HD.'
    },
    search: {

    },
    contact: {
      title: 'Contactez-nous par e-mail, Twitter, Facebook, Instagram et Youtube. -Loklok',
      keywords: 'Twitter, Facebook, Instagram,Regardez en ligne,Regardez gratuitement, Regardez des drames gratuitement, Youtube, Contact, E-mail',
      description: 'Les questions sur loklok peuvent être communiquées par e-mail, Twitter, Facebook, Instagram et Youtube'
    }
  },
  globalTip: {
    emptyTip: 'vide～',
    searchOther: 'Essayez de rechercher d\'autres films ou émissions de télévision'
  },
  loginModule: {
    title: ' Connexion ',
    loginMethod: ' Scanner le code QR via l\'application loklok ',
    loginMethodTip: ' (La version doit être mise à jour vers 1.7.0 et plus) ',
    howToDownload: ' Comment télécharger loklok ',
    clickMe: ' Cliquez ici ',
    loginSuccess: ' Connexion réussie ',
    loginFailed: ' Échec de la connexion ',
    codeExpired: ' Le code QR a expiré ! ',
    refreshButton: ' Rafraîchir ',
    loginButton: ' Connexion ',
    loginTip: ' Consulter gratuitement le contenu de l\'ensemble du site web après s\'être connecté',
    logoutButton: ' Se déconnecter ',
    logoutTip: ' Profitez du film ! ',
    areYouSure: ' Êtes-vous sûr de vouloir vous déconnecter ? ',
    sure: ' OK ',
    cancel: ' Annuler '
  },
  toTop: {
    downloadApp: ' Télécharger l\'application ',
    backToTop: ' Retour en haut de page '
  },
  indexPage: {
    title: ' LolokTV ',
    more: ' Voir plus ',
    seeMore: ' Lire la suite '
  },
  searchPage: {
    resultTitle: 'Résultats de Recherche: ',
    rank: 'Le plus populaire de Loklok',
    play: ' Relecture ',
    popularSearch: ' Recherche la plus effectué ',
    top1: ' N° 1 ',
    top2: ' N° 2 ',
    top3: ' N° 3 ',
    top4: ' N° 4 ',
    top5: ' N° 5 ',
    top6: ' N° 6 ',
    top7: ' N° 7 ',
    top8: ' N° 8 ',
    top9: ' N° 9 ',
    top10: ' N° 10 ',
    emptyTip: ' Désolé, ce contenu n\'est pas fourni ici ',
    emptyDesc: ' Essayez de rechercher d\'autres films ou de séries télévisées '
  },
  filterPage: {
    emptyTip: ' Désolé, ce contenu n\'est pas fourni ici ',
    emptyDesc: ' Essayer de rechercher d\'autres films ou de séries télévisées '
  },
  newsPage: {
    listTitle: ' Dernières nouvelles '
  },
  downloadPage: {
    scanQR: ' Scanner le code QR pour télécharger l\'application ',
    title1: 'Films et drames populaires',
    tip1: 'Regardez-le à tout moment gratuitement',
    title2: 'sous-titres multilingues',
    tip2: 'Regardez le drame facilement',
    title3: 'Synchronisation PC/Téléphone en temps réel'
  },
  detailPage: {
    autoTranslation: 'traduction automatique',
    fiveMiniteTip: 'Seulement 5min, Regardez le film complet après',
    loginTip2InDetailPage: ' Scannez le code QR ci-dessous via l\'application loklok, et consultez le reste du contenu après vous être connecté ',
    category: ' Classification ',
    moreDesc: ' Voir plus',
    youMayLike: ' Devinez vos favoris ',
    relatedSeries: ' Séries apparentées ',
    norelatedSeries: ' Il n\'y a pas de séries connexes ',
    emptyDesc: ' Désolé, ce contenu n\'est pas fourni ici ',
    emptyTip: ' Désolé, ce contenu n\'est pas fourni ici ',
    vip: {
      dialog: {
        t1: 'Ouvrir un VIP',
        t2: 'Pour regarder tout le contenu, veuillez ouvrir le VIP dans l\'application',
        t3: 'L\'application peut être téléchargée des façons suivantes',
        t4: 'Avez-vous déjà un VIP ? Veuillez <span class="active">cliquer ici</span> pour vous connecter',
        t5: 'Avez-vous déjà un VIP ? Veuillez <span class="active">actualiser</span> pour continuer à regarder',
        t6: 'Vous avez regardé {num} minutes, si vous souhaitez continuer à regarder la vidéo complète,veuillez accéder à l\'application, ou après avoir ouvert le VIP dans l\'application, vous pouvez continuer à parcourir la vidéo'
      },
      player: {
        tip1: 'Vous ne pouvez regarder que {num} minutes, veuillez regarder le film en entier <span class="active">dans l\'application</span> ou <span class="active">ouvrir le VIP</span>'
      },
      episodes: {
        tip1: 'Devenez un VIP et profitez de tout le contenu'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: ' Le navigateur est en train de télécharger des données ',
    NETWORK_NO_SOURCE: ' Aucune source audio/vidéo n\'est trouvée ',
    MEDIA_ERR_ABORTED: ' Le processus de récupération est interrompu par l\'utilisateur ',
    MEDIA_ERR_NETWORK: ' Une erreur se produit pendant le téléchargement ',
    MEDIA_ERR_DECODE: ' Une erreur se produit pendant l\'analyse de la lecture:  Aucun fichier ne peut être lu ',
    MEDIA_ERR_SRC_NOT_SUPPORTED: ' Le format audio/vidéo n\'est pas pris en charge ',
    REPLAY: ' Relecture ',
    ERROR: ' Une erreur se produit dans la connexion réseau ',
    PLAY_TIPS: ' Relecture ',
    PAUSE_TIPS: ' Pause ',
    PLAYNEXT_TIPS: ' Épisode suivant ',
    DOWNLOAD_TIPS: ' Télécharger ',
    ROTATE_TIPS: ' Tourner ',
    RELOAD_TIPS: ' Recharger ',
    FULLSCREEN_TIPS: ' Vers le plein écran ',
    EXITFULLSCREEN_TIPS: ' Quitter le plein écran ',
    CSSFULLSCREEN_TIPS: ' Vers le plein écran pour le style ',
    EXITCSSFULLSCREEN_TIPS: ' Quitter le plein écran pour le style ',
    TEXTTRACK: ' Sous-titres ',
    PIP: ' Incrustation d\'image',
    MINIPLAYER: ' Mini lecteur ',
    SCREENSHOT: ' Capture d\'écran ',
    LIVE: ' Diffusion directe',
    OFF: ' Désactiver ',
    MINIPLAYER_DRAG: ' Cliquez et maintenez pour faire glisser la vidéo ',
    AIRPLAY_TIPS: ' Airplay ',
    onlyPlayTip: ' Ne jouer que les {msg} minutes, et se connecter pour voir le film complet ',
    loginTextButton: ' Se connecter ',
    replayButton: ' Relecture',
    nextButton: ' Prochain épisode ',
    refreshButton: ' Rafraîchir ',
    episode: ' Épisode '
  },
  contact: {
    business: 'La coopération commerciale',
    question: 'retour d\'information'
  },
  download_nd: {
    desc: 'De nombreux téléfilms et feuilletons tous gratuits !',
    scanQR: 'Téléchargement d\'APP après la lecture du code QR ou'
  },
  win: {
    feedback: {
      que: 'Explication des questions fréquentes',
      que1: 'Questions Fréquemment Posées',
      content: 'Contenu des Retours',
      contact: 'Informations de Contact',
      submit: 'Envoyez vos commentaires',
      tip1: ' Veuillez fournir une description détaillée, et vous pouvez également inclure des captures d’écran pertinentes.',
      tip2: 'Veuillez entrer votre e-mail.',
      tip5: 'La taille de l’image téléchargée doit être inférieure à {num}k.',
      tip6: 'Un maximum de 4 images peut être téléchargé.',
      tip3: 'Soumis, veuillez patienter.',
      tip4: 'Le contenu du retour doit comporter au moins 10 mots.',
      error: 'Erreur Système'
    }
  },
  tv: {
    vip: {
      title: 'Veuillez sélectionner votre produit',
      tip1: 'Vous pouvez voir le code QR de paiement après vous être connecté.',
      refresh: 'Actualiser',
      tip2: 'Scannez le code QR pour le paiement',
      recharge: 'Contrat de Recharge',
      renewal: 'Contrat de Renouvellement',
      login: 'Connectez-vous maintenant',
      tip3: 'Voir après la connexion',
      noOpen: 'VIP Standard Non Activé',
      gift: 'Cadeau',
      succ: 'Rafraîchissement réussi',
      fail: 'Échec du rafraîchissement',
      day: 'VIP standard 1 jour',
      days: 'VIP standard {x} jours',
      expiration: 'Temps d’expiration VIP standard : {x}',
      expired: 'Votre VIP a expiré, veuillez le renouveler rapidement.',
      interests1: 'Profitez de la qualité HD 1080P',
      interests2: 'Débloquez tout le contenu',
      interests3: 'Connexion multi-appareils'
    }
  }
}